import { takeLatest } from 'redux-saga/effects';
import { CHECK_CADASTRAL_FIELDS } from '../../actions/rosreestrData';
import { checkCadastralFields } from './checkCadastralFields';

export function* rosreestrDataSagas() {
  yield takeLatest(CHECK_CADASTRAL_FIELDS, checkCadastralFields);
}
